import { connect } from "react-redux";
import InspectionFormMail from "./inspectionFormMail";
import { bindActionCreators } from "redux";
import { getInspectionForm} from "services/redux/maintenance/inspectionForm/action";
import { viewSiteInspectionForms } from "services/redux/sales/postSaleListing/action";
import { sendInspectionMail} from "services/redux/maintenance/inspectionForm/action";

const mapStateToProps = (state) => ({
    siteInspectionList: state.postSalesListReducer.siteInspectionList,
    viewInspectionForms: state.InspectionReducer.viewInspectionForms,
    getInspectionForms: state.InspectionReducer.getInspectionForm,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getInspectionForm,
        viewSiteInspectionForms,
        sendInspectionMail
    },
    dispatch
  );

  export default connect(mapStateToProps, mapDispatchToProps)(InspectionFormMail);
